<template>
  <section>
    <v-layout justify-center align-center class="pb-8">
      <img src="@/assets/logo/funda-logo-white.png" />
      <v-icon color="white" class="mx-3">mdi-close</v-icon>
      <img src="@/assets/logo/gov-smes-full.png" />
    </v-layout>
    <v-layout class="px-3">
      <div class="title">
        <h3 class="font--m-3">2026년 우리동네 크라우드펀딩 모집</h3>
      </div>
    </v-layout>
    <v-layout class="px-3" justify-center>
      <p class="text-center white--text mb-0 font-size--14">
        우리동네 크라우드펀딩 대출형<br />소상공인이 동네 주민(개인 투자자)에게<br />
        사업자금을 빌리고 이자를 상환하는 크라우드펀딩
      </p>
    </v-layout>
  </section>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
section {
  padding: 40px 0;
  background-color: #15b1ff;

  .layout:not(:last-of-type) {
    margin-bottom: 16px;
  }

  img {
    max-height: 50px;
    max-width: 30%;
  }

  .title {
    background-color: #f8ffcb;
    border-radius: 16px;
    width: 100%;
    text-align: center;
  }
}
</style>
